import React from 'react'
import '../css/footer.css'
import icon1 from "../imgs/footerIcons/PathfooterIcons.svg"
import icon2 from "../imgs/footerIcons/ShapefooterIcons 2.svg"
import icon3 from "../imgs/footerIcons/PathfooterIcons 2.svg"
import icon4 from "../imgs/footerIcons/ShapefooterIcons 3.svg"
import icon5 from "../imgs/footerIcons/ShapefooterIcons 4.svg"
import icon6 from "../imgs/footerIcons/ShapefooterIcons.svg"
import { Link } from 'react-router-dom'
import { useContext } from 'react'
import { api } from '../api'


const Footer = () => {
  const { t, language } = useContext(api)

  return (
    <footer>
      <div className="footer-content" style={language === "ar" ? {direction: "rtl"} : {direction: "ltr"}}>
        <div className="footer-left" style={language === "ar" ? {direction: "rtl"} : {direction: "ltr"}}>
          <nav>
            <Link to={"/"}>{t("home")}</Link>
            <Link to={"/about-us"}>{t("aboutUs")}</Link>
            <Link to={"/contact-us"}>{t("contactUs")}</Link>
            <a target='_blank' href={"https://linktr.ee/YoussefAbotaleb"} rel="noreferrer">{t("getweb")}</a>
          </nav>
        </div>
        <div className="footer-right">
          <a target='_blank' href="tel:+20224192049" rel="noreferrer"><img className="footerIcons" src= {icon1} alt="" /></a>
          <a target='_blank' href="mailto:info@unitedgroupeg.com" rel="noreferrer"><img className="footerIcons" src= {icon2} alt="" /></a>
          <a target='_blank' href="https://www.facebook.com/profile.php?id=100003579131291" rel="noreferrer"><img className="footerIcons" src= {icon3} alt="" /></a>
          <a target='_blank' href="https://www.instagram.com/mohamedabotaleb_/" rel="noreferrer"><img className="footerIcons" src= {icon4} alt="" /></a>
          <a target='_blank' href="https://wa.me/+201153272244" rel="noreferrer"><img className="footerIcons" src= {icon5} alt="" /></a>
          <a target='_blank' href="https://maps.app.goo.gl/VbX1j96Y65HFNiE1A" rel="noreferrer"><img className="footerIcons" src= {icon6} alt="" /></a>
        </div>
      </div>
      <p className="copyRightMsg" style={language === "ar" ? {direction: "rtl"} : {direction: "ltr"}}>{t("footerCopyRightMessage")} &copy;</p> 
    </footer>
  )
}

export default Footer